import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function CheckOutActivity({item}) {
    const { t } = useTranslation()
    
    // Función auxiliar getPrice similar a la que se usa en Description.js y Group.js
    const getPrice = (price) => {
        if (price && !isNaN(price)) {
            const activity = item.commission?.find(activity => price >= activity.lowPrice && price <= activity.highPrice);
            if (activity) {
                return price > 0 ? (price + (Math.ceil(((price * (activity.percentage || 0) / 100) + (activity.double || 0)) * 100) / 100)).toFixed(2) : parseFloat(price).toFixed(2)
            } else {
                return parseFloat(price).toFixed(2)
            }
        } else {
            return '0.00'
        }
    }

    const calculateActivityPrice = (item) => {
        // Obtener la matrícula
        let registrationPayment = 0
        if (item.group.registrationPayment?.maxdate && new Date(item.group.registrationPayment?.maxdate) >= new Date()) {
            registrationPayment = parseFloat(item.group.registrationPayment.price)
        }
        
        // Calcular el impacto de las respuestas a las preguntas sobre la matrícula
        const registrationImpact = item.questions
        .reduce((sum, question) => {
            const registrationPercentageTotal = (parseFloat(registrationPayment) * ((parseFloat(question?.impact?.registrationPercentage || 0)) / 100))
            return parseFloat(sum) + (parseFloat(registrationPercentageTotal)) + (question?.impact?.registrationQuantity || 0);
        }, 0)
        
        // Obtener todos los pagos de temporada
        const allSeasonPayments = item.group.seasonPayments || [];
        
        // Calcular el precio total de todos los pagos de temporada con impactos
        let totalSeasonPaymentsWithImpact = 0;
        
        allSeasonPayments.forEach(payment => {
            const paymentImpact = item.questions
            .reduce((questionTotal, question) => {
                const seasonPaymentPercentageTotal = (parseFloat(payment.price) * ((parseFloat(question?.impact?.seasonPaymentPercentage || 0)) / 100));
                return parseFloat(questionTotal) + (parseFloat(seasonPaymentPercentageTotal)) + (question?.impact?.seasonPaymentQuantity || 0);
            }, 0);
            
            totalSeasonPaymentsWithImpact += parseFloat(paymentImpact) + parseFloat(payment.price);
        });
        
        // Aplicar promociones si existen
        if (item.promotions) {
            // Este código se mantiene por compatibilidad, pero utiliza los resultados finales
            // para el cálculo correcto con getPrice
        }
        
        // Calculamos el precio de la matrícula más el impacto con comisión
        const registrationPaymentWithImpactAndCommission = parseFloat(getPrice(registrationPayment + registrationImpact));
        
        // Luego calculamos el precio total de los pagos de temporada con impactos y comisión
        const seasonPaymentsWithImpactAndCommission = parseFloat(getPrice(totalSeasonPaymentsWithImpact));
        
        // El precio total es la suma de ambos con 2 decimales
        const totalPriceWithCommission = (registrationPaymentWithImpactAndCommission + seasonPaymentsWithImpactAndCommission).toFixed(2);
        
        return totalPriceWithCommission;
    }

    return (
        <Row className='border py-4 px-3 rounded my-5'>
            <Col xs={12} md={4}>
                <img src={item.activity.image || `/images/sports/${item.activity?.sport}.jpg`} alt={item.activity.title} className="w-100"/>
            </Col>
            <Col xs={12} md={8}>
                <Row className='mb-5'>
                    <Col xs={8}>
                        <h3>{item.group.title}</h3>
                    </Col>
                    <Col xs={4}>
                        <div className='border rounded group-price text-center py-3'>
                            <div className='fw-bold'>{calculateActivityPrice(item)}€</div>
                            {item.group.verify && <div className='small text-muted'>Pendiente autorización</div>}
                        </div>
                    </Col>
                </Row>
                <div className='mt-3'>
                    <div className='d-flex justify-content-between align-items-end'>
                        <span className='fw-bold'>{t("marketplace.activity.member")}</span>
                        <span>{item.client?.lastname} {item.client?.firstname}</span>
                    </div>
                    <hr className='border my-1'/>
                </div>
                <div className='mt-3'>
                    <div className='d-flex justify-content-between align-items-end'>
                        <span className='fw-bold'>{t("marketplace.activity.category")}</span>
                        <span>{item.group.category.title}</span>
                    </div>
                    <hr className='border my-1'/>
                </div>
                <div className='mt-3'>
                    <div className='d-flex justify-content-between align-items-end'>
                        <span className='fw-bold'>{t("marketplace.activity.federated")}</span>
                        <span>{item.group.federated ? t('global.yes') : t('global.no')}</span>
                    </div>
                    <hr className='border my-1'/>
                </div>
                <div className='mt-3'>
                    <div className='d-flex justify-content-between align-items-end'>
                        <span className='fw-bold'>{t("marketplace.activity.age")}</span>
                        <span>{item.group.category.ageFrom} - {item.group.category.ageTo} {t('marketplace.activity.yearsOld')}</span>
                    </div>
                    <hr className='border my-1'/>
                </div>
                {item?.group?.assignableHorary ?
                    <div className='mt-3'>
                        <div className='d-flex justify-content-between align-items-end'>
                            <span className='fw-bold'>{t("marketplace.activity.horary")}</span>
                            <span>{item.group.horaries.find(g => g._id === item.horary)?.name || ''}</span>
                        </div>
                        <hr className='border my-1'/>
                    </div>
                :
                    ''
                }
                {
                    item.questions?.map((question, questionIndex) => (
                        <div className='mt-3' key={questionIndex}>
                            <div className='d-flex justify-content-between align-items-end'>
                                <span className='fw-bold'>{question.question}</span>
                                <span>{question.answer}</span>
                            </div>
                            <hr className='border my-1'/>
                        </div>
                    ))
                }
            </Col>
        </Row>
    )
}